<template>
    <router-link v-if="collaIdx" :to="linkuse"  class="flex items-center justify-center cursor-pointer block aspect-square"
                    
                    :style=" 
                        collaIdx.patro?.length?{
                            backgroundColor: collaIdx.codi_color,
                            backgroundImage: `url(${require('@/assets/patrons/' + collaIdx.patro[0])})`,
                            backgroundPosition: `center`,
                            backgroundSize: `${collaIdx.patro[1]}%`
                        }:
                        collaIdx.codi_color!=='#ffffff'?{backgroundColor: collaIdx.codi_color}:
            
                        {backgroundColor:'#e0e0e0'}">
                       <div class="aspect-square w-full h-full"  :class="!collaIdx.xy_escut?.length&&collaIdx.color_hsl[2]>=50?'brightness-0':{}" 
                         
                :style="collaIdx.xy_escut?.length?
                    {
                    
                    backgroundImage: `url(${escutsSprite})`, 
                    backgroundPosition: `${-100*collaIdx.xy_escut[0]}% ${-100*collaIdx.xy_escut[1]}%` ,
                    backgroundSize: 100*12+'%'}:
                    {
                        backgroundImage:`url(${escutDesconegut})`,
                        backgroundSize:100+'%',
                        opacity:'50%'
                        }">
                </div>
               <tippy v-if="props.tippy==true" :key=colla.id to="parent" content-tag="div" content-class="w-fit"> 
                <TargetaPerfil tema="fosc" :colla="colla" class="w-72"/>
            </tippy>
            </router-link>
    <div v-else class=" flex items-center justify-center cursor-pointer block aspect-square bg-red-200 text-center overflow-hidden" 
                :style="
                        {backgroundImage:`url(${escutDesconegut})`,
                        backgroundSize:100+'%',
                        opacity:'50%'}
                        ">
        <p>Colla no trobada: {{ colla }}</p>
    </div>
</template>

<script setup>
import {inject,defineProps,ref} from 'vue'
import escutDesconegut from '@/assets/escuts/escut_desconegut.svg'
//import TargetaInfo from './TargetaInfo.vue'
import TargetaPerfil from './TargetaPerfil.vue'

const props = defineProps({
    colla:{
        type:String,
        required:false
    },

    obj:{
        type:Object,
        required:false,
    },
    tippy:{
        type:Boolean,
        required:false,
        default:true
    },
    link:{
        type:String,
        required:false,
        default:''
    }
})

const dades = inject('dades')
const escutsSprite = inject('escutsSprite')
const collaIdx=ref(null)

const objecte=ref(props.obj)



if (props.colla){
    collaIdx.value=dades.find(c=>c.id===props.colla)
}
else if (objecte.value){
    collaIdx.value=objecte.value
}
else{
    collaIdx.value=null
}

const linkuse =ref(props.link || ('/' + collaIdx.value.llista + '/' + collaIdx.value.id))
</script>